import urls from '@/networkRequests/apiClient/endpoints'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import errorHandler from '../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../shared/types/api.types'
import { getAllOfferRequestsForAdminApi } from './getAllOfferRequestsForAdmin.api'
import getAllOfferRequestsForAdminInitialState from './getAllOfferRequestsForAdmin.initialState'
import {
  GetAllOfferRequestsForAdminErrorResponse,
  GetAllOfferRequestsForAdminRequestPayload
} from './getAllOfferRequestsForAdmin.types'

export const getAllOfferRequestsForAdmin = createAsyncThunk(
  urls.admin.getAllOfferRequestsForAdmin,
  async (payload: GetAllOfferRequestsForAdminRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getAllOfferRequestsForAdminApi(request)

      if (onSuccess) {
        onSuccess()
      }

      return response
    } catch (error) {
      return rejectWithValue(error as ApiErrorResponse)
    }
  }
)

const getAllOfferRequestsForAdminSlice = createSlice({
  name: 'getAllOfferRequestsForAdmin',
  initialState: getAllOfferRequestsForAdminInitialState,
  reducers: {
    resetGetAllOfferRequestsForAdmin: () => getAllOfferRequestsForAdminInitialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllOfferRequestsForAdmin.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getAllOfferRequestsForAdmin.fulfilled, (state, action) => {
        state.loading = false
        state.success = action.payload
      })
      .addCase(getAllOfferRequestsForAdmin.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as GetAllOfferRequestsForAdminErrorResponse
        errorHandler.handleApiError(action.payload as GetAllOfferRequestsForAdminErrorResponse, undefined, true)
      })
  }
})

export const getAllOfferRequestsForAdminActions = {
  ...getAllOfferRequestsForAdminSlice.actions,
  getAllOfferRequestsForAdmin
}

export default getAllOfferRequestsForAdminSlice.reducer
